/**
 * This file is intended to contain all the constants used common in the front-end
 */

import { CONSTANTS } from '@tpco/tpco-saturn-types';
import { canBeEdited } from 'util/p3Validation';
const campaignHasFulfillment: (productFulfillment: any) => Boolean = (productFulfillment: any) => {
  return productFulfillment ? true : false;
};

const campaignIsOptimization: (campaignStatusId: number) => boolean = (
  campaignStatusId: number
) => {
  return campaignStatusId === CONSTANTS.CAMPAIGN_STATUS.OPTIMIZE_NEW;
};

const readOnlyConfiguration: (
  campaignStatusId: number,
  startDate: string,
  opportunityId: string,
  orderSource?: string
) => boolean = (
  campaignStatusId: number,
  startDate: string,
  opportunityId: string,
  orderSource?: string
) => {
  return (
    CONSTANTS.NO_MORE_CHANGES_CAMPAIGN.includes(campaignStatusId) ||
    !canBeEdited(campaignStatusId, startDate, opportunityId, orderSource)
  );
};

const TABS_CONFIGURATIONS = {
  ASSIGNED: 'Associated Configurations',
  UNASSIGNED: 'Configuration Templates'
};

export {
  campaignHasFulfillment,
  campaignIsOptimization,
  readOnlyConfiguration,
  TABS_CONFIGURATIONS
};
